

const Preloader = () => {
  return (
    <div className="preloader-catalog main-full">
      <div className="preloader-container">
        <div className="preloader"></div>
      </div>
      <h2>
        Мы подобрали наилучшие совпадения
        по вашему запросу!
      </h2>
    </div>
  )
}

export default Preloader
